// @ts-nocheck
import customAxios from '../utils/axios';
import axios from 'axios';
import { MONITORING_API_ENDPOINT, ONLINE_REPORT_SERVICE_API_ENDPOINT } from '../config';
import { catchAsync } from '../utils/api';

const CancelToken = axios.CancelToken;
let cancel;

const getSports = catchAsync(async params => {
    if (cancel) cancel();

    const result = await customAxios.get(MONITORING_API_ENDPOINT + '/sports', { params });

    return result.data;
});

const getEvents = catchAsync(async ({ resourceType, ...body }) => {
    const result = await customAxios.post(MONITORING_API_ENDPOINT + `/events/${resourceType}/query`, body, {
        cancelToken: new CancelToken(function executor(c) {
            cancel = c;
        }),
    });

    return result.data;
});

const getEventMarkets = catchAsync(async ({ resourceType, ...params }) => {
    const result = await customAxios.get(MONITORING_API_ENDPOINT + `/market/${resourceType}`, { params });

    return result.data;
});

const getEventHistory = catchAsync(async params => {
    const result = await customAxios.get(MONITORING_API_ENDPOINT + '/event-history', { params });

    return result.data;
});

const getEventRiskValues = catchAsync(async ({ resourceType, eventId, ...params }) => {
    const result = await customAxios.get(MONITORING_API_ENDPOINT + `/events/${resourceType}/${eventId}/risk-values`, {
        params,
    });

    return result.data;
});

const getEventTickets = catchAsync(async ({ resourceType, eventId, ...params }) => {
    const result = await customAxios.get(MONITORING_API_ENDPOINT + `/events/${resourceType}/${eventId}/bet-lines`, {
        params,
    });

    return result.data;
});

const freezeEvent = catchAsync(async params => {
    const { resourceType, eventId, channel } = params;
    const result = await customAxios.patch(
        MONITORING_API_ENDPOINT + `/events/${resourceType}/${eventId}/freeze?&channel=${channel}`,
    );

    return result.data;
});

const unfreezeEvent = catchAsync(async params => {
    const { resourceType, eventId, channel } = params;
    const result = await customAxios.patch(
        MONITORING_API_ENDPOINT + `/events/${resourceType}/${eventId}/unfreeze?&channel=${channel}`,
    );

    return result.data;
});

const freezeMarket = catchAsync(async ({ marketId, ...body }) => {
    const result = await customAxios.patch(MONITORING_API_ENDPOINT + `/market/${marketId}/freeze`, body);

    return result.data;
});

const unfreezeMarket = catchAsync(async ({ marketId, ...body }) => {
    const result = await customAxios.patch(MONITORING_API_ENDPOINT + `/market/${marketId}/unfreeze`, body);

    return result.data;
});

const freezeOutcome = catchAsync(async ({ marketId, outcomeRefId, ...body }) => {
    const result = await customAxios.patch(
        MONITORING_API_ENDPOINT + `/market/${marketId}/outcome/${outcomeRefId}/freeze`,
        body,
    );
    return result.data;
});
const unfreezeOutcome = catchAsync(async ({ marketId, outcomeRefId, ...body }) => {
    const result = await customAxios.patch(
        MONITORING_API_ENDPOINT + `/market/${marketId}/outcome/${outcomeRefId}/unfreeze`,
        body,
    );
    return result.data;
});

const cancelEvent = catchAsync(async params => {
    const { resourceType, eventId, channel } = params;
    const result = await customAxios.patch(
        MONITORING_API_ENDPOINT + `/events/${resourceType}/${eventId}/cancel?&channel=${channel}`,
    );

    return result.data;
});

const changeMbn = catchAsync(async body => {
    const result = await customAxios.post(MONITORING_API_ENDPOINT + '/mbn', body);

    return result.data;
});

const changeMaxWinAmount = catchAsync(async ({ marketId, ...body }) => {
    const result = await customAxios.patch(MONITORING_API_ENDPOINT + `/market/${marketId}/max-win-amount`, body);

    return result.data;
});

const getSettlementTickets = catchAsync(async ({ params, cancelToken }) => {
    const result = await customAxios.get(ONLINE_REPORT_SERVICE_API_ENDPOINT + '/settlement/tickets', {
        params,
        cancelToken,
    });

    return result.data;
});

const getSettlementMarkets = catchAsync(async ({ params, cancelToken }) => {
    const result = await customAxios.get(MONITORING_API_ENDPOINT + '/settlement/markets', { params, cancelToken });

    return result.data;
});

const changeTicketSettlementStatus = catchAsync(async body => {
    const result = await customAxios.post(MONITORING_API_ENDPOINT + '/settlement/ticket', body);

    return result.data;
});

const changeMarketsSettlementStatus = catchAsync(async body => {
    const result = await customAxios.post(MONITORING_API_ENDPOINT + '/settlement/event', body);

    return result.data;
});

const MonitoringService = {
    getSports,
    getEvents,
    getEventMarkets,
    getEventHistory,
    getEventRiskValues,
    getEventTickets,
    cancelEvent,
    freezeEvent,
    unfreezeEvent,
    freezeMarket,
    unfreezeMarket,
    freezeOutcome,
    unfreezeOutcome,
    changeMbn,
    changeMaxWinAmount,
    getSettlementTickets,
    getSettlementMarkets,
    changeTicketSettlementStatus,
    changeMarketsSettlementStatus,
};

export default MonitoringService;
